<script lang="ts" setup>
  import { Button } from '../ui/button'
  import { useOAuth } from '~/composables/auth/useOAuth'
  import { useSessionExpiry } from '~/composables/auth/useSessionExpiry'

  const oauth = useOAuth()
  const ws = useWebSocket()
  const { isAutoLoggedOut, triggerSessionExpired } = useSessionExpiry()

  const handleButtonClick = (): void => {
    navigateTo(oauth.buildRedirectUrl('logout'), { external: true })
  }

  const stopSessionExpiredHandler = ws.on('session_expired', triggerSessionExpired)
  onUnmounted(stopSessionExpiredHandler)
</script>

<template>
  <div
    v-if="isAutoLoggedOut"
    class="absolute top-0 left-0 h-screen w-full z-50 bg-primary/30 backdrop-blur-sm flex items-center justify-center"
  >
    <div class="rounded-lg bg-white shadow p-4 w-80 text-sm space-y-4">
      <h2 class="font-semibold text-primary">{{ $t('inactivityMonitor.title') }}</h2>
      <p class="text-xs+ text-content">{{ $t('inactivityMonitor.description') }}</p>

      <Button variant="default" class="text-white mt-4" @click="handleButtonClick">
        {{ $t('inactivityMonitor.signInAgain') }}
      </Button>
    </div>
  </div>
</template>
